import type {
  GoHighLevelContact,
  GoHighLevelConversation,
  GoHighLevelEntity,
  GoHighLevelMessage,
  GoHighLevelOpportunity,
  GoHighLevelTab,
} from "@/types/gohighlevel";

export function formatGoHighLevelMarkdown(
  entity: GoHighLevelEntity,
  tab: GoHighLevelTab,
  messages?: GoHighLevelMessage[]
): string {
  const lines: string[] = [`# GoHighLevel: ${entity.subject}`, ""];

  if (tab === "conversations") {
    const c = entity as GoHighLevelConversation;
    lines.push(
      `- **Contact:** ${c.subject}`,
      c.contactId ? `- **Contact ID:** ${c.contactId}` : null,
      c.channel ? `- **Channel:** ${c.channel}` : null,
      `- **Date:** ${c.date}`,
      ""
    );
    if (messages?.length) {
      lines.push("## Messages", "");
      for (const m of messages) {
        lines.push(`### ${m.from} — ${m.date}`, "", m.body || m.preview, "");
      }
    } else {
      lines.push(c.preview || "");
    }
  } else if (tab === "contacts") {
    const c = entity as GoHighLevelContact;
    lines.push(
      `- **Name:** ${c.subject}`,
      c.email ? `- **Email:** ${c.email}` : null,
      c.phone ? `- **Phone:** ${c.phone}` : null,
      c.tags?.length ? `- **Tags:** ${Array.isArray(c.tags) ? c.tags.join(", ") : String(c.tags)}` : null,
      `- **Date:** ${c.date}`,
      "",
      c.preview || ""
    );
  } else if (tab === "opportunities") {
    const o = entity as GoHighLevelOpportunity;
    lines.push(
      `- **Deal:** ${o.subject}`,
      `- **Stage:** ${o.from}`,
      o.monetaryValue != null ? `- **Value:** $${o.monetaryValue}` : null,
      o.contactId ? `- **Contact ID:** ${o.contactId}` : null,
      `- **Date:** ${o.date}`,
      "",
      o.preview || ""
    );
  } else {
    lines.push(
      `- **Calendar:** ${entity.subject}`,
      `- **Date:** ${entity.date}`,
      "",
      entity.preview || ""
    );
  }

  return lines.filter((l) => l !== null).join("\n");
}

export function goHighLevelMetadata(
  entity: GoHighLevelEntity,
  tab: GoHighLevelTab
): Record<string, unknown> {
  return {
    source: "gohighlevel",
    tab,
    externalId: entity.id,
    subject: entity.subject,
    type: entity.type || tab,
    date: entity.date,
  };
}
